import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { Connect, PropsFromRedux } from './ExcludeContainer';
import { CommonSection } from '../CommonSection';
import { searchConstants } from '../../../search-utils/searchConstants';
import { doctrineAnalytics } from '../../../../utils/analyticsUtils';
import { UserContextType } from '../../../../user/user.types';
import { withUser } from '../../../../user/UserContext';
import { SearchCheckbox } from '../checkbox/SearchCheckbox';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

export class RawExclude extends React.Component<Props> {
  excludePart = () => {
    const {
      accessPremium,
      toggleCheckbox,
      openRestrictedModal,
      excludeMoyensAnnexes,
    } = this.props;
    if (!accessPremium) {
      openRestrictedModal('faceted-item');
    } else {
      doctrineAnalytics('Search ExcludeMeansClicked', {
        type: excludeMoyensAnnexes ? 'deselect' : 'select',
      });
      toggleCheckbox();
    }
  };

  render() {
    const { excludeMoyensAnnexes } = this.props;
    return (
      <CommonSection title={searchConstants.filters.exclude}>
        <SearchCheckbox
          title="Exclure les moyens annexés (Cour de cassation)"
          onClick={this.excludePart}
          isSelected={excludeMoyensAnnexes}
        >
          <FormattedMessage id="search/components/aside-filters/exclude/Exclude.tsx/1" />
        </SearchCheckbox>
      </CommonSection>
    );
  }
}

export const Exclude = withUser(withRestrictedModal(Connect(RawExclude)));
